import React from 'react';

// Save-status line for the admin draft composer. Fixed height in every state so
// the input area never shifts as the text changes.
//
// `mutedClassName` lets each host match its own palette — AdminSupportChat is
// slate throughout, the inbox composer is gray.
export function DraftStatus({ saveState, lastSavedAt, loadError = false, mutedClassName = 'text-slate-400' }) {
  let text = '';
  let className = mutedClassName;

  if (loadError) {
    // Sending still works; only drafting is off, because saving over a draft we
    // could not read might destroy it.
    text = 'Draft not available — this message will not be saved';
    className = 'text-amber-600';
  } else if (saveState === 'saving') {
    text = 'Saving…';
  } else if (saveState === 'saved') {
    text = lastSavedAt
      ? `Draft saved ${lastSavedAt.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
      : 'Draft saved';
  } else if (saveState === 'error') {
    text = 'Not saved — retrying';
    className = 'text-amber-600';
  }

  return (
    <div className={`h-4 mt-1 px-1 text-xs leading-4 ${className}`}>{text}</div>
  );
}

export default DraftStatus;
